<template>
  <div>
    <app-template>

      <!-- Header -->
      <div class="mb-6 mt-4">
        <h1 class="text-2xl font-semibold text-gray-900">Planning</h1>
        <p class="text-sm text-gray-500">
          Suivez vos plannings, interventions et chantiers en un coup d'œil.
        </p>
      </div>

      <!-- Tabs -->
      <!-- <div class="flex md:inline-flex justify-between md:justify-start items-center gap-1 bg-white border border-gray-200 rounded-xl p-1 mb-2 shadow-sm">
        <button
          v-for="tab in tabs"
          :key="tab.key"
          @click="currentTab = tab.key"
          class="relative flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150"
          :class="currentTab === tab.key
            ? 'bg-orange-200 text-orange-900 shadow-sm'
            : 'text-gray-500 hover:text-slate-800 hover:bg-slate-200'"
        >
          <i class="hidden md:block" :class="[tab.icon, 'text-xs']"></i>
          {{ tab.label }}
          <span
            v-if="tab.badge"
            class="ml-0.5 text-[10px] font-bold px-2 py-0.5 rounded-full bg-orange-50 text-orange-700"
          >
            {{ tab.badge }}
          </span>
        </button>
      </div> -->

      <!-- Panel -->
      <component :is="selectedComponent" class="mt-2" />

    </app-template>
  </div>
</template>

<script>
import InterventionList from './InterventionList.vue';
import ChantierList from '../Chantier/ChantierList.vue';
import PlanningPage from '../Planning/PlanningPage.vue';

export default {
  components: { InterventionList, ChantierList, PlanningPage },

  data() {
    return {
      currentTab: 'planning',
      tabs: [
        { key: 'planning',      label: 'Planning',      icon: 'fas fa-calendar', badge: null },
        { key: 'chantiers',     label: 'Liste des chantiers',     icon: 'fas fa-helmet-safety', badge: null },
        // { key: 'interventions', label: 'Interventions', icon: 'fas fa-wrench',     badge: null    },
      ],
    };
  },

  computed: {
    selectedComponent() {
      const map = {
        planning:      'PlanningPage',
        interventions: 'InterventionList',
        chantiers:     'ChantierList',
      };
      return map[this.currentTab];
    },
  },
};
</script>